import React, { Component } from 'react';
import moment from "moment-jalaali";

export class PersianDatePicker extends Component {
    static displayName = PersianDatePicker.name;


    constructor(props) {
        super(props);
        this.state = {};

        this.state.value = null;
        this.state.text = this.props.text;

        this.yearData = [];
        this.monthData = [];
        this.dayData = [];

        this.handleChange = this.handleChange.bind(this);
        this.setSelectOptions = this.setSelectOptions.bind(this);


    }

    componentDidMount() {
        this.setSelectOptions(false);
        this.setState({});
    }

    handleChange(e) {
        this.setState({});


        var node = this.refs.dayRef;
        var node1 = this.refs.monthRef;
        var node2 = this.refs.yearRef;

        var day = node.value;
        var month = node1.value;
        var year = node2.value;


        if (day > 0 && month > 0 && year > 0) {

            console.log(year + '/' + month + '/' + day);
            e = moment(year + '/' + month + '/' + day, 'jYYYY/jM/jD');
            var res = null;
            if (e != null) {
                res = e.format('YYYY/M/D');
            }

            //console.log(this.state.value);
            if (typeof this.props.onChange === "function")
                this.props.onChange(res, this.props.name);
        }
    }

    setSelectOptions(update) {

        if (!update) {
            this.yearData = [];
            var t = { id: "", name: "سال" };
            this.yearData.push(t);
            for (var i = 1420; i > 1390; i--) {
                var t = {};
                t.id = i;
                t.name = i;
                this.yearData.push(t);
            }


            this.monthData = [];
            var t = { id: "-1", name: "ماه" };
            this.monthData.push(t);
            for (var i = 1; i < 13; i++) {
                var t = {};
                t.id = i;
                t.name = n(i);
                this.monthData.push(t);
            }

        }
        this.dayData = [];
        var t = { id: "-1", name: "روز" };
        this.dayData.push(t);
        for (var i = 1; i < 32; i++) {
            var t = {};
            t.id = i;
            t.name = n(i);
            this.dayData.push(t);
        }
    }



    render() {

        var styles = {
            calendarContainer: "calendarContainer",
            dayPickerContainer: "dayPickerContainer",
            monthsList: "monthsList",
            daysOfWeek: "daysOfWeek",
            dayWrapper: "dayWrapper",
            selected: "selected",
            heading: "heading",
            next: "next",
            prev: "prev",
            title: "title",
            currentMonth: "currentMonth"
        };


        var optionsyear = this.yearData.map((data) =>
            <option key={data.id} value={data.id}>{data.name}</option>
        );

        var optionsmonth = this.monthData.map((data) =>
            <option key={data.id} value={data.id}>{data.name}</option>
        );


        var optionsday = this.dayData.map((data) =>
            <option key={data.id} value={data.id}>{data.name}</option>
        );


        return (




            <div class="input-group" style={{ width: "100%" }}>
                <div class="input-group-prepend" style={{ width: "30%" }}>
                    <span class="input-group-text" style={{ width: "100%" }}>{this.props.label}</span>
                </div>


                <select className="custom-select"
                    ref="dayRef"
                    onChange={this.handleChange}>


                    {optionsday}
                </select>

                <select className="custom-select"
                    ref="monthRef"
                    onChange={this.handleChange} >
                    {optionsmonth}
                </select>

                <select className="custom-select"
                    ref="yearRef"
                    onChange={this.handleChange} >
                    {optionsyear}
                </select>


            </div>


        );
    }
}
function n(n){
    return n > 9 ? "" + n: "0" + n;
}



// WEBPACK FOOTER //
// ./src/elements/PersianDatePicker.js